export default __webpack_public_path__ + "static/media/google_play.4fb2bac2.png";